import { defineMessages } from 'react-intl'

export default defineMessages({
  quoteHeader: {
    id: 'app.quote.header',
    defaultMessage: 'Request a Quote',
  },
  quoteListAuto: {
    id: 'app.quote.list.auto',
    defaultMessage: 'Auto',
  },
  quoteListProperty: {
    id: 'app.quote.list.property',
    defaultMessage: 'Property',
  },
  quoteListCommercial: {
    id: 'app.quote.list.commercial',
    defaultMessage: 'Commercial',
  },
  quoteListLife: {
    id: 'app.quote.list.life',
    defaultMessage: 'Life',
  },
  quotePlaceholderName: {
    id: 'app.quote.placeholder.name',
    defaultMessage: 'Your name',
  },
  quotePlaceholderNumber: {
    id: 'app.quote.placeholder.number',
    defaultMessage: 'Your phone number',
  },
  quotePlaceholderEmail: {
    id: 'app.quote.placeholder.email',
    defaultMessage: 'Your email',
  },
  quotePlaceholderDate: {
    id: 'app.quote.placeholder.date',
    defaultMessage: 'Effective Date',
  },
  quotePlaceholderComments: {
    id: 'app.quote.placeholder.comments',
    defaultMessage: 'Comments',
  },
  quoteValidationName: {
    id: 'app.quote.validation.name',
    defaultMessage: 'Please enter your name!',
  },
  quoteValidationNameValid: {
    id: 'app.quote.validation.nameValid',
    defaultMessage: 'Please enter a valid name!',
  },
  quoteValidationNumber: {
    id: 'app.quote.validation.number',
    defaultMessage: 'Please enter your phone number!',
  },
  quoteValidationEmailValid: {
    id: 'app.quote.validation.emailValid',
    defaultMessage: 'Please enter a valid email!',
  },
  quoteValidationEmailRequired: {
    id: 'app.quote.validation.emailRequired',
    defaultMessage: 'Please enter your email!',
  },
  quoteValidationEmailNotValid: {
    id: 'app.quote.validation.emailNotValid',
    defaultMessage: 'Please enter valid email!',
  },
  quoteNotificationThankYou: {
    id: 'app.quote.notification.thankYou',
    defaultMessage: 'Thank you',
  },
  quoteNotificationSuccessMsg: {
    id: 'app.quote.notification.success',
    defaultMessage: 'Someone will reach out to you shortly.',
  },
  quoteNotificationError: {
    id: 'app.quote.notification.error',
    defaultMessage: 'Something went wrong',
  },
})
